import { type FC } from 'react';
import { StringSmall } from '@components/Typography/Typography';

import { Picture } from '../Picture/Picture';

import css from './styles.module.scss';

import timerPng from '/img/icons/timer.png';
import timerWebp from '/img/icons/timer.webp';

interface TimerProps {
  value: string;
}

const Timer: FC<TimerProps> = ({ value }) => {
  return (
    <div className={css.timer}>
      <div className="w-[55px] flex items-center justify-center">
        <StringSmall weight="medium" className="tabular-nums">
          {value}
        </StringSmall>
      </div>
      <Picture
        className="absolute left-[2px] top-1/2 -translate-y-1/2 w-[24px] h-[24px] shrink-0"
        webp={timerWebp}
        img={timerPng}
        alt="timer"
      />
    </div>
  );
};

export { Timer };
